import React from 'react';

// COMPONENTS
import Icon from '../Icon';

// ENUMS
import { CarouselVariant } from '../../enums/carousel.enum';
import { Icons } from '../../enums/icons';

// INTERFACES
import { ICarouselButtons } from '../../interfaces/Carousel.interface';

// STYLES
import { CarouselButton, CarouselButtonsContainer } from './styles';

const CarouselButtons: React.FC<ICarouselButtons> = ({ variant = CarouselVariant.GROUP, nextButton, prevButton, next, previous }): JSX.Element => {
  return (
    <CarouselButtonsContainer variant={variant}>
      <CarouselButton
        id={prevButton.id}
        onClick={previous}
        title={prevButton.text || `Retornar para o item anterior`}
      >
        <Icon type={Icons.ARROW_LEFT} />
      </CarouselButton>
      <CarouselButton
        id={nextButton.id}
        onClick={next}
        title={nextButton.text || `Avançar para o próximo item`}
      >
        <Icon type={Icons.ARROW_RIGHT} />
      </CarouselButton>
    </CarouselButtonsContainer>
  );
};

export default CarouselButtons;
